import Box from '@mui/material/Box'; 
import { Link } from 'react-router-dom'; 
import Grid from '@mui/material/Grid2';
import '../styles/Header.css';

function Footer() {

    return( 
<Box
    mt={3}
    p={2}
    className="header"
>
    <Grid
        container
        spacing={4}
        justifyContent="center"
        alignItems="center"
    >
        <Grid>
            <Link to="/copyright">Copyright</Link>
        </Grid>

        <Grid>
            <div title="esorex2@asnr.fr">
                <a
                    style={{ textDecoration: "underline", color: "blue" }}
                    href="mailto:esorex2@asnr.fr"
                >
                    Contact us
                </a>
            </div>
        </Grid>
    </Grid>
</Box>
    );
}

export default Footer;

